// extracted by mini-css-extract-plugin
export default {"personalisationElement":"PersonalizationContent_personalisationElement__hD2Vw","isBuilding":"PersonalizationContent_isBuilding__QGQv7"};